import script from "./adminTable.vue?vue&type=script&setup=true&lang=js"
export * from "./adminTable.vue?vue&type=script&setup=true&lang=js"

import "./adminTable.vue?vue&type=style&index=0&id=10087024&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10087024"]])

export default __exports__